import AlbertRivera from '../assets/persons/albert-rivera.png';
import InigoErrejon from '../assets/persons/inigo-errejon.png';
import GabrielRufian from '../assets/persons/gabriel-rufian.png';
import PabloCasado from '../assets/persons/pablo-casado2.png';
import PabloIglesias from '../assets/persons/pablo-iglesias.png';
import PedroSanchez from '../assets/persons/pedro-sanchez.png';
import SantiagoAbascal from '../assets/persons/santiago-abascal.png'; // export const placeholder = placeholder;

export const persons = {
  AlbertRivera: AlbertRivera,
  InigoErrejon: InigoErrejon,
  GabrielRufian: GabrielRufian,
  PabloCasado: PabloCasado,
  PedroSanchez: PedroSanchez,
  SantiagoAbascal: SantiagoAbascal,
  PabloIglesias: PabloIglesias
};
export const parties = [{
  key: 'PSOE',
  name: 'Partido Socialista Obrero Español',
  shortname: 'PSOE',
  color: '#e30613',
  person: {
    name: 'Pedro Sánchez',
    photo: PedroSanchez
  },
  desc: 'Escucha de la conversación en las cuentas de Twitter de PSOE Nacional, Pedro Sánchez, Adriana Lastra, José Luis Ábalos, Carmen Calvo y María Jesús Montero.'
}, {
  key: 'PP',
  name: 'Partido Popular',
  shortname: 'PP',
  color: '#0cb2ff',
  person: {
    name: 'Pablo Casado',
    photo: PabloCasado
  },
  desc: 'Escucha de la conversación en las cuentas de Twitter de Partido Popular Nacional, Pablo Casado, Dolors Monserrat, Teodoro García, Cayetana Álvarez de Toledo y Ana Pastor.'
}, {
  key: 'Ciudadanos',
  name: 'Ciudadanos',
  shortname: 'Cs',
  color: '#ff6d1a',
  person: {
    name: 'Albert Rivera',
    photo: AlbertRivera
  },
  desc: 'Escucha de la conversación en las cuentas de Twitter de Ciudadanos Nacional, Albert Rivera, Inés Arrimadas, Ignacio Aguado, Begoña Villacís, Juan Carlos Girauta y Toni Cantó'
}, {
  key: 'Podemos',
  name: 'Unidas Podemos',
  shortname: 'UP',
  color: '#6a1f5f',
  person: {
    name: 'Pablo Iglesias',
    photo: PabloIglesias
  },
  desc: 'Escucha de la conversación en las cuentas de Twitter de Ahora Podemos Nacional, Pablo Iglesias, Pablo Echenique, Irene Montero, Alberto Garzón, Julio Rodriguez y Teresa Rodríguez'
}, {
  key: 'Vox',
  name: 'VOX',
  shortname: 'VOX',
  color: '#7cbd2a',
  person: {
    name: 'Santiago Abascal',
    photo: SantiagoAbascal
  },
  desc: 'Escucha de la conversación en las cuentas de Twitter de Vox Nacional, Santiago Abascal, Javier Ortega Smith, Alejo Vidal Quadras, Francisco Serrano, Ignacio Garriga y Iván Espinosa'
}, {
  key: 'ERC',
  name: 'Esquerra Republicana de Catalunya',
  shortname: 'ERC',
  color: '#ffb232',
  person: {
    name: 'Gabriel Rufián',
    photo: GabrielRufian
  },
  desc: 'Escucha de la conversación en las cuentas de Twitter de Esquerra Republicana, Gabriel Rufián y Joan Tardá'
}, {
  key: 'MásPaís',
  name: 'MásPaís',
  shortname: 'Más País',
  color: '#0fddc4',
  person: {
    name: 'Íñigo Errejón',
    photo: InigoErrejon
  },
  desc: 'Escucha de la conversación en las cuentas de Twitter de Más País, Íñigo Errejón, Mónica Oltra y Joan Baldoví'
}];